const hasUpperCase = (str: string) => /[A-Z]/.test(str);
const hasLoweCase = (str: string) => /[a-z]/.test(str);
const hasNumber = (str: string) => /[0-9]/.test(str);
const hasSpecialCharacter = (str: string) => /[^a-zA-Z0-9]/.test(str);

// Password security check
export const checkPassword = (value: string) => {
  return (
    !hasLoweCase(value) ||
    !hasUpperCase(value) ||
    !hasNumber(value) ||
    !hasSpecialCharacter(value)
  );
};
